import React, { useEffect, useState } from "react";
import { fetchChildren } from "../../services/Api";
import { useAuth } from "../../services/AuthContext";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";

const SelectChildPage = () => {
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);
  const [isSpinnerLoading, setIsSpinnerLoading] = useState(true);
  const { familyID, updateChildID } = useAuth();

  useEffect(() => {
    if (!familyID) return;

    const getChildren = async () => {
      try {
        const minDelay = new Promise(resolve => setTimeout(resolve, 200));
        const [kids] = await Promise.all([
          fetchChildren(familyID),
          minDelay
        ]);
        setChildren(kids);
      } catch (error) {
        console.error('Error fetching children:', error);
      } finally {
        setIsSpinnerLoading(false);
      }
    };

    getChildren();
  }, [familyID]);

  return (
    <>
      <LoadingSpinner isLoading={isSpinnerLoading} />
      <div className={`centered-child-selection-container fade-in ${!isSpinnerLoading ? "visible" : ""}`}>
        <h1>Who Are You?</h1>
        <div>
          {children.map((child) => (
            <div key={child.ChildID} style={{ padding: 8, width: "100%" }}>
              <button
                className="kidNameButton"
                onClick={() => {
                  updateChildID(child.ChildID);
                  navigate("/savings")
                }}
              >
                {child.FirstName} <span className="ml-2">&#8594;</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SelectChildPage;